import { render, staticRenderFns } from "./list-categories.vue?vue&type=template&id=51a9f042&scoped=true&"
import script from "./list-categories.vue?vue&type=script&lang=ts&"
export * from "./list-categories.vue?vue&type=script&lang=ts&"
import style0 from "./list-categories.vue?vue&type=style&index=0&id=51a9f042&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a9f042",
  null
  
)

export default component.exports